// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive font size for .font-74-to-108 class */
.font-74-to-158 {
  /* 
    The font size is set using the clamp() function, which takes three parameters: 
    1. Minimum size: 74px.
    2. Preferred size: A dynamic size that scales with the viewport width, calculated using a formula.
    3. Maximum size: 158px.
    */
  font-size: clamp(
    74px,
    74px + (158 - 74) * ((100vw - 428px) / (1920 - 428)),
    158px
  );
  /* 
    The formula within the clamp function calculates a size between 74px and 158px, 
    scaling linearly as the viewport width (vw) increases from 428px to 1920px. 
    Below 428px or above 1920px, the size is clamped to 74px or 158px, respectively.
    */
}

/* Media query for very small screens */
@media screen and (max-width: 427px) {
  .font-74-to-158 {
    /* For screens narrower than 427px, the font size scales with the viewport width */
    font-size: 17.29vw; /* This results in a dynamic font size that's a percentage of the viewport width */
  }
}



/* Responsive font size for .font-40-to-108 class */
.font-40-to-108 {
  /* 
    The font size is set using the clamp() function, which takes three parameters: 
    1. Minimum size: 40px.
    2. Preferred size: A dynamic size that scales with the viewport width, calculated using a formula.
    3. Maximum size: 108px.
    */
  font-size: clamp(
    40px,
    40px + (108 - 40) * ((100vw - 428px) / (1920 - 428)),
    108px
  );
  /* 
    The formula within the clamp function calculates a size between 40px and 108px, 
    scaling linearly as the viewport width (vw) increases from 428px to 1920px. 
    Below 428px or above 1920px, the size is clamped to 40px or 108px, respectively.
    */
}

/* Media query for very small screens */
@media screen and (max-width: 427px) {
  .font-40-to-108 {
    /* For screens narrower than 427px, the font size scales with the viewport width */
    font-size: 9.37vw; /* This results in a dynamic font size that's a percentage of the viewport width */
  }
}


/* Responsive font size for .font-21-to-40 class */
.font-21-to-40 {
  /* 
    The font size is set using the clamp() function, which takes three parameters: 
    1. Minimum size: 21px.
    2. Preferred size: A dynamic size that scales with the viewport width, calculated using a formula.
    3. Maximum size: 40px.
    */
  font-size: clamp(
    21px,
    21px + (40 - 21) * ((100vw - 428px) / (1920 - 428)),
    40px
  );
  /* 
    The formula within the clamp function calculates a size between 21px and 40px, 
    scaling linearly as the viewport width (vw) increases from 428px to 1920px. 
    Below 428px or above 1920px, the size is clamped to 21px or 40px, respectively.
    */
}

/* Media query for very small screens */
@media screen and (max-width: 427px) {
  .font-21-to-40 {
    /* For screens narrower than 427px, the font size scales with the viewport width */
    font-size: 4.9vw; /* This results in a dynamic font size that's a percentage of the viewport width */
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/fontSizing.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE;;;;;KAKG;EACH;;;;GAIC;EACD;;;;KAIG;AACL;;AAEA,uCAAuC;AACvC;EACE;IACE,kFAAkF;IAClF,kBAAkB,EAAE,kFAAkF;EACxG;AACF;;;;AAIA,mDAAmD;AACnD;EACE;;;;;KAKG;EACH;;;;GAIC;EACD;;;;KAIG;AACL;;AAEA,uCAAuC;AACvC;EACE;IACE,kFAAkF;IAClF,iBAAiB,EAAE,kFAAkF;EACvG;AACF;;;AAGA,kDAAkD;AAClD;EACE;;;;;KAKG;EACH;;;;GAIC;EACD;;;;KAIG;AACL;;AAEA,uCAAuC;AACvC;EACE;IACE,kFAAkF;IAClF,gBAAgB,EAAE,kFAAkF;EACtG;AACF","sourcesContent":["/* Responsive font size for .font-74-to-108 class */\n.font-74-to-158 {\n  /* \n    The font size is set using the clamp() function, which takes three parameters: \n    1. Minimum size: 74px.\n    2. Preferred size: A dynamic size that scales with the viewport width, calculated using a formula.\n    3. Maximum size: 158px.\n    */\n  font-size: clamp(\n    74px,\n    74px + (158 - 74) * ((100vw - 428px) / (1920 - 428)),\n    158px\n  );\n  /* \n    The formula within the clamp function calculates a size between 74px and 158px, \n    scaling linearly as the viewport width (vw) increases from 428px to 1920px. \n    Below 428px or above 1920px, the size is clamped to 74px or 158px, respectively.\n    */\n}\n\n/* Media query for very small screens */\n@media screen and (max-width: 427px) {\n  .font-74-to-158 {\n    /* For screens narrower than 427px, the font size scales with the viewport width */\n    font-size: 17.29vw; /* This results in a dynamic font size that's a percentage of the viewport width */\n  }\n}\n\n\n\n/* Responsive font size for .font-40-to-108 class */\n.font-40-to-108 {\n  /* \n    The font size is set using the clamp() function, which takes three parameters: \n    1. Minimum size: 40px.\n    2. Preferred size: A dynamic size that scales with the viewport width, calculated using a formula.\n    3. Maximum size: 108px.\n    */\n  font-size: clamp(\n    40px,\n    40px + (108 - 40) * ((100vw - 428px) / (1920 - 428)),\n    108px\n  );\n  /* \n    The formula within the clamp function calculates a size between 40px and 108px, \n    scaling linearly as the viewport width (vw) increases from 428px to 1920px. \n    Below 428px or above 1920px, the size is clamped to 40px or 108px, respectively.\n    */\n}\n\n/* Media query for very small screens */\n@media screen and (max-width: 427px) {\n  .font-40-to-108 {\n    /* For screens narrower than 427px, the font size scales with the viewport width */\n    font-size: 9.37vw; /* This results in a dynamic font size that's a percentage of the viewport width */\n  }\n}\n\n\n/* Responsive font size for .font-21-to-40 class */\n.font-21-to-40 {\n  /* \n    The font size is set using the clamp() function, which takes three parameters: \n    1. Minimum size: 21px.\n    2. Preferred size: A dynamic size that scales with the viewport width, calculated using a formula.\n    3. Maximum size: 40px.\n    */\n  font-size: clamp(\n    21px,\n    21px + (40 - 21) * ((100vw - 428px) / (1920 - 428)),\n    40px\n  );\n  /* \n    The formula within the clamp function calculates a size between 21px and 40px, \n    scaling linearly as the viewport width (vw) increases from 428px to 1920px. \n    Below 428px or above 1920px, the size is clamped to 21px or 40px, respectively.\n    */\n}\n\n/* Media query for very small screens */\n@media screen and (max-width: 427px) {\n  .font-21-to-40 {\n    /* For screens narrower than 427px, the font size scales with the viewport width */\n    font-size: 4.9vw; /* This results in a dynamic font size that's a percentage of the viewport width */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
